import { defineMessages } from 'react-intl';

export default defineMessages({
  proposed: {
    id: 'core.assistantBricks.proposedValueBadge.proposed',
    defaultMessage: 'Proposed',
  },
});
